/**
 * Detect Next.js's `redirect()` exception. `redirect()` throws an Error
 * tagged with a `digest` starting with `NEXT_REDIRECT` so the App Router
 * can intercept and perform the navigation. When such a redirect crosses
 * a try/catch in user code (e.g. after `await someServerAction()`), the
 * catch must re-throw or the redirect is swallowed *and* downstream
 * "error logged" handlers fire on every successful navigation.
 *
 * Mirrors the check used in `apps/platform/src/app/select-patient/actions.ts`.
 */
export function isRedirectError(error: unknown): boolean {
  return (
    !!error &&
    typeof error === "object" &&
    "digest" in error &&
    typeof (error as { digest: unknown }).digest === "string" &&
    (error as { digest: string }).digest.startsWith("NEXT_REDIRECT")
  );
}
